module.exports = __webpack_public_path__ + "h360_banner-89b994b461e2418b7f7c270060cd7e0d.jpg";